import { Link, useNavigate } from "react-router-dom";
import ListingSlider from "../components/ListingSlider";
import DynamicPortalText from "../components/DynamicPortalText";

export default function Home({ keycloak }) {
  const navigate = useNavigate();

  const handleLogin = () => {
    navigate("/login");
  };

  const handleRegister = () => {
    navigate("/register");
  };

  const handleWhatsApp = () => {
    const phoneNumber = "5511918783914"; // Número do WhatsApp do setor de vendas
    const message = encodeURIComponent("Olá! Gostaria de falar com o setor de vendas sobre o Sistema Único - Imobiliárias.");
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, "_blank");
  };

  return (
    <div className="container">
      <section className="hero">
        <div style={{ textAlign: "center", maxWidth: "800px", margin: "0 auto" }}>
          <DynamicPortalText />
          
          <div style={{ marginTop: "3rem", marginBottom: "2rem" }}>
            <ListingSlider />
          </div>

          <div style={{ display: "flex", gap: "1rem", justifyContent: "center", marginTop: "2rem", flexWrap: "wrap" }}>
            <Link to="/listings">
              <button
                className="btn-primary"
                style={{ fontSize: "1.1rem", padding: "1rem 2rem" }}
              >
                🔍 Ver Todos os Anúncios
              </button>
            </Link>
            <button
              className="btn-primary"
              onClick={handleRegister}
              style={{ fontSize: "1.1rem", padding: "1rem 2rem" }}
            >
              Cadastre-se
            </button>
            <button
              className="btn-primary"
              onClick={handleLogin}
              style={{ 
                fontSize: "1.1rem", 
                padding: "1rem 2rem"
              }}
            >
              Entrar no Sistema
            </button>
          </div>
        </div>
      </section>

      <section>
        <h2 className="section-title">Funcionalidades do Sistema</h2>
        <div className="grid grid-3">
          <div className="panel">
            <div style={{ fontSize: "2.5rem", marginBottom: "1rem" }}>🔍</div>
            <h3>Busca Inteligente por IA</h3>
            <p>
              Descreva o imóvel desejado e o sistema busca automaticamente em Quinto Andar,
              Viva Real e Zap Imóveis com classificação semântica.
            </p>
          </div>
          <div className="panel">
            <div style={{ fontSize: "2.5rem", marginBottom: "1rem" }}>📄</div>
            <h3>Gestão de Contratos</h3>
            <p>
              Contratos inteligentes com geração automática, reajustes programados,
              alertas de vencimento, documentos com validade e gestão completa do ciclo de vida.
            </p>
          </div>
          <div className="panel">
            <div style={{ fontSize: "2.5rem", marginBottom: "1rem" }}>💳</div>
            <h3>Cobrança Automatizada</h3>
            <p>
              Geração automática de boletos e PIX, controle de inadimplência,
              repasses automáticos e dashboards financeiros completos.
            </p>
          </div>
          <div className="panel">
            <div style={{ fontSize: "2.5rem", marginBottom: "1rem" }}>🔐</div>
            <h3>Análise de Crédito</h3>
            <p>
              Motor de crédito integrado com consultas em SERASA, SPC e Receita Federal
              para análise completa de locatários com score e recomendações.
            </p>
          </div>
          <div className="panel">
            <div style={{ fontSize: "2.5rem", marginBottom: "1rem" }}>💳</div>
            <h3>Pagamentos via Cartão</h3>
            <p>
              Processamento de pagamentos via cartão de crédito para locação de cotas,
              com parcelamento e integração com gateways de pagamento.
            </p>
          </div>
          <div className="panel">
            <div style={{ fontSize: "2.5rem", marginBottom: "1rem" }}>🏢</div>
            <h3>Gestão de Condomínios</h3>
            <p>
              Administração completa de condomínios, aluguel de espaços comuns,
              salões de festas e áreas de lazer.
            </p>
          </div>
          <div className="panel">
            <div style={{ fontSize: "2.5rem", marginBottom: "1rem" }}>📊</div>
            <h3>Gerenciamento de Cotas</h3>
            <p>
              Controle completo de cotas imobiliárias, frações e timeshares
              com gestão de cotistas e investimentos.
            </p>
          </div>
          <div className="panel">
            <div style={{ fontSize: "2.5rem", marginBottom: "1rem" }}>💬</div>
            <h3>Comunicação WhatsApp</h3>
            <p>
              Integração direta com WhatsApp para envio automático de mensagens,
              notificações e comunicação com clientes.
            </p>
          </div>
          <div className="panel">
            <div style={{ fontSize: "2.5rem", marginBottom: "1rem" }}>🔔</div>
            <h3>Alertas e Lembretes</h3>
            <p>
              Sistema automático de alertas para vencimentos, reajustes,
              documentos expirando e manutenções programadas.
            </p>
          </div>
        </div>
      </section>

      <section>
        <h2 className="section-title">Opções de Locação</h2>
        <div className="grid grid-4">
          <div className="panel" style={{ textAlign: "center", padding: "2rem" }}>
            <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>🏢</div>
            <h3>Imóveis</h3>
            <p style={{ color: "var(--text-secondary)", marginTop: "0.5rem" }}>
              Apartamentos, casas, sobrados e coberturas para locação residencial ou comercial.
            </p>
          </div>
          <div className="panel" style={{ textAlign: "center", padding: "2rem" }}>
            <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>🏛️</div>
            <h3>Salas Comerciais</h3>
            <p style={{ color: "var(--text-secondary)", marginTop: "0.5rem" }}>
              Escritórios, salas comerciais e lojas em pontos estratégicos para seu negócio.
            </p>
          </div>
          <div className="panel" style={{ textAlign: "center", padding: "2rem" }}>
            <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>🌳</div>
            <h3>Terrenos</h3>
            <p style={{ color: "var(--text-secondary)", marginTop: "0.5rem" }}>
              Terrenos para construção, investimento ou uso comercial em diversas localizações.
            </p>
          </div>
          <div className="panel" style={{ textAlign: "center", padding: "2rem" }}>
            <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>📊</div>
            <h3>Cotas Imobiliárias</h3>
            <p style={{ color: "var(--text-secondary)", marginTop: "0.5rem" }}>
              Investimento em cotas, frações e timeshares com pagamento via cartão de crédito.
            </p>
          </div>
        </div>
      </section>

      <section>
        <h2 className="section-title">Nossos Planos</h2>
        <div className="grid grid-4 pricing-cards">
          <div className="panel pricing-card">
            <h3>Gratuito</h3>
            <div className="price">R$ 0<span>/mês</span></div>
            <p style={{ color: "var(--text-secondary)", marginBottom: "1.5rem" }}>
              Para começar a organizar seus contratos.
            </p>
            <ul style={{ listStyle: "none", padding: 0, marginBottom: "1.5rem" }}>
              <li style={{ padding: "0.5rem 0" }}>✅ 1 Contrato</li>
              <li style={{ padding: "0.5rem 0" }}>✅ Cadastro de Contratos</li>
              <li style={{ padding: "0.5rem 0" }}>✅ Geração de Boletos</li>
              <li style={{ padding: "0.5rem 0" }}>✅ Busca Inteligente</li>
              <li style={{ padding: "0.5rem 0" }}>❌ Gerenciamento de Condomínio</li>
              <li style={{ padding: "0.5rem 0" }}>❌ Gerenciamento de Cotas</li>
              <li style={{ padding: "0.5rem 0" }}>❌ Análise de Crédito</li>
            </ul>
            <button className="btn-primary" onClick={handleRegister} style={{ width: "100%" }}>
              Começar Grátis
            </button>
          </div>

          <div className="panel pricing-card popular">
            <div className="popular-badge">MAIS POPULAR</div>
            <h3>Básico</h3>
            <div className="price">R$ 49<span>,90/mês</span></div>
            <p style={{ color: "var(--text-secondary)", marginBottom: "1.5rem" }}>
              Ideal para pequenas imobiliárias.
            </p>
            <ul style={{ listStyle: "none", padding: 0, marginBottom: "1.5rem" }}>
              <li style={{ padding: "0.5rem 0" }}>✅ Até 10 Contratos</li>
              <li style={{ padding: "0.5rem 0" }}>✅ Todas as funcionalidades do Gratuito</li>
              <li style={{ padding: "0.5rem 0" }}>✅ Geração de PIX</li>
              <li style={{ padding: "0.5rem 0" }}>✅ Gerenciamento de Contas a Pagar</li>
              <li style={{ padding: "0.5rem 0" }}>✅ Análise de Crédito</li>
              <li style={{ padding: "0.5rem 0" }}>❌ Gerenciamento de Condomínio</li>
              <li style={{ padding: "0.5rem 0" }}>❌ Gerenciamento de Cotas</li>
            </ul>
            <button className="btn-primary" onClick={handleRegister} style={{ width: "100%" }}>
              Assinar Agora
            </button>
          </div>

          <div className="panel pricing-card">
            <h3>Profissional</h3>
            <div className="price">R$ 119<span>,90/mês</span></div>
            <p style={{ color: "var(--text-secondary)", marginBottom: "1.5rem" }}>
              Para imobiliárias em crescimento.
            </p>
            <ul style={{ listStyle: "none", padding: 0, marginBottom: "1.5rem" }}>
              <li style={{ padding: "0.5rem 0" }}>✅ Até 30 Contratos</li>
              <li style={{ padding: "0.5rem 0" }}>✅ Todas as funcionalidades do Básico</li>
              <li style={{ padding: "0.5rem 0" }}>✅ Gerenciamento de Condomínio</li>
              <li style={{ padding: "0.5rem 0" }}>✅ Aluguel de Espaços Comuns</li>
              <li style={{ padding: "0.5rem 0" }}>✅ Pagamentos via Cartão</li>
              <li style={{ padding: "0.5rem 0" }}>❌ Gerenciamento de Cotas</li>
            </ul>
            <button className="btn-primary" onClick={handleRegister} style={{ width: "100%" }}>
              Assinar Agora
            </button>
          </div>

          <div className="panel pricing-card">
            <h3>Condomínio</h3>
            <div className="price">R$ 5<span>/unidade/mês</span></div>
            <p style={{ color: "var(--text-secondary)", marginBottom: "1.5rem" }}>
              Solução completa para administração de condomínios com cobrança automatizada.
            </p>
            <ul style={{ listStyle: "none", padding: 0, marginBottom: "1.5rem" }}>
              <li style={{ padding: "0.5rem 0" }}>✅ Acima de 30 Contratos</li>
              <li style={{ padding: "0.5rem 0" }}>✅ Todas as funcionalidades do Profissional</li>
              <li style={{ padding: "0.5rem 0" }}>✅ Gerenciamento de Cotas</li>
              <li style={{ padding: "0.5rem 0" }}>✅ Gestão Completa de Condomínios</li>
              <li style={{ padding: "0.5rem 0" }}>✅ Cobrança via PIX, Cartão e Automática</li>
              <li style={{ padding: "0.5rem 0" }}>✅ Recuperação de Crédito (10% do valor recuperado)</li>
              <li style={{ padding: "0.5rem 0" }}>✅ Negativação Automática de Inadimplentes</li>
              <li style={{ padding: "0.5rem 0" }}>✅ Suporte Dedicado</li>
            </ul>
            <button 
              className="btn-primary" 
              onClick={handleWhatsApp} 
              style={{ 
                width: "100%",
                background: "#25D366",
                border: "none"
              }}
              onMouseEnter={(e) => {
                e.target.style.background = "#20BA5A";
              }}
              onMouseLeave={(e) => {
                e.target.style.background = "#25D366";
              }}
            >
              💬 Falar com Vendas
            </button>
          </div>
        </div>
      </section>

      <section style={{ marginTop: "3rem", textAlign: "center" }}>
        <h2 className="section-title">Pronto para começar?</h2>
        <p style={{ fontSize: "1.1rem", color: "var(--text-secondary)", marginBottom: "2rem" }}>
          Experimente todas as funcionalidades do Sistema Único - Imobiliárias
        </p>
        <div style={{ display: "flex", gap: "1rem", justifyContent: "center", flexWrap: "wrap" }}>
          <button
            className="btn-primary"
            onClick={handleRegister}
            style={{ fontSize: "1.1rem", padding: "1rem 2.5rem" }}
          >
            Cadastre-se
          </button>
          <button
            className="btn-primary"
            onClick={handleLogin}
            style={{ 
              fontSize: "1.1rem", 
              padding: "1rem 2.5rem"
            }}
          >
            Entrar no Sistema
          </button>
            <button
              onClick={handleWhatsApp}
              style={{ 
                fontSize: "1.1rem", 
                padding: "1rem 2.5rem",
                background: "#25D366",
                border: "none",
                color: "#ffffff",
                borderRadius: "var(--radius-md)",
                cursor: "pointer",
                fontWeight: 500,
                transition: "var(--transition)"
              }}
              onMouseEnter={(e) => {
                e.target.style.background = "#20BA5A";
                e.target.style.transform = "translateY(-1px)";
              }}
              onMouseLeave={(e) => {
                e.target.style.background = "#25D366";
                e.target.style.transform = "translateY(0)";
              }}
            >
              💬 Falar com Vendas
            </button>
          </div> 
      </section>
    </div>
  );
}
